import { FEATURE_FLAGS } from 'utils/constants';
import type { Features } from './FeatureTogglesProvider.types';

export const featureTogglesDefaultValues: Features = {
  ...FEATURE_FLAGS,
};
